"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mintTokenValidationSchema = exports.tokenMintAssetValidationSchema = exports.tokenAssetComponentValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const types_1 = require("@framework/types");
exports.tokenAssetComponentValidationSchema = (0, yup_1.object)().shape({
    amount: mui_inputs_asset_1.tokenAssetAmountValidationSchema,
    contract: (0, yup_1.object)().shape({
        decimals: (0, yup_1.number)()
            .min(0, "form.validations.valueMissing")
            .integer("form.validations.badInput")
            .required("form.validations.valueMissing"),
        address: yup_rules_eth_1.addressValidationSchema,
    }),
    contractId: yup_rules_1.dbIdValidationSchema,
    token: (0, yup_1.object)().when("tokenType", {
        is: (tokenType) => tokenType !== types_1.TokenType.ERC20 && tokenType !== types_1.TokenType.NATIVE,
        then: schema => schema.shape({
            tokenId: (0, yup_1.number)()
                .min(0, "form.validations.valueMissing")
                .integer("form.validations.badInput")
                .required("form.validations.valueMissing"),
        }),
    }),
    tokenId: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
    templateId: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
    tokenType: mui_inputs_asset_1.tokenAssetTokenTypeValidationSchema,
});
exports.tokenMintAssetValidationSchema = (0, yup_1.object)().shape({
    components: (0, yup_1.array)().of(exports.tokenAssetComponentValidationSchema),
});
exports.mintTokenValidationSchema = (0, yup_1.object)().shape({
    account: yup_rules_eth_1.addressValidationSchema,
    template: mui_inputs_asset_1.templateAssetValidationSchema,
    token: exports.tokenMintAssetValidationSchema,
});
//# sourceMappingURL=validation.js.map